import { render, staticRenderFns } from "./DashboardCoordinator.vue?vue&type=template&id=5f84f8fa&"
import script from "./DashboardCoordinator.vue?vue&type=script&lang=js&"
export * from "./DashboardCoordinator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports